// src/components/RequireAuth.js
import { useAuth } from "react-oidc-context";

export const RequireAuth = ({ children }) => {
  const auth = useAuth();

  if (auth.isLoading) return <div>Loading authentication...</div>;
  if (auth.error) return <div>Error: {auth.error.message}</div>;

  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return <div>Redirecting to login...</div>;
  }

  return children;
};
